import { render, staticRenderFns } from "./DeliveryRouteConfigForm.vue?vue&type=template&id=460d9408"
import script from "./DeliveryRouteConfigForm.vue?vue&type=script&lang=js"
export * from "./DeliveryRouteConfigForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports